import { connect } from 'react-redux';
import Checker from './Checker';
import { checkInit } from '../../actions/app';

const mapStateToProps = ({ app, user }) => ({
  checkPassed: app.checkPassed,
  checkIsPending: app.checkIsPending,
  userId: user.id,
  userRole: user.role,
});

const mapDispatchToProps = dispatch => ({
  checkInit: () => dispatch(checkInit()),
});

const CheckerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Checker);

export default CheckerContainer;



// WEBPACK FOOTER //
// ./src/components/Checker/CheckerContainer.js